import {timeToDecimal} from '../../../utils/utils';
import {BaseTaskRes, ProjectMinRes} from '../crm';
import {Type} from 'class-transformer';

export class ActualAppointmentReq {
    startString!: string;
    endString!: string;
    description: string;
    color: string
    taskId?: string

    set start(date: Date) {
        this.startString = date.toISOString()
    }

    get start() {
        return new Date(this.startString);
    }

    set end(date: Date) {
        this.endString = date.toISOString()
    }

    get end() {
        return new Date(this.endString);
    }

    constructor(startTime: Date, endTime: Date, description: string, color: string, task?: BaseTaskRes) {
        this.start = startTime;
        this.end = endTime;
        this.description = description;
        this.color = color;
        this.taskId = task?.id
    }
}

export class ActualAppointmentCollectionReq {
    newAppointments: ActualAppointmentReq[] = []
    editAppointments: ActualAppointmentUpdateReq[] = []

    constructor(value: Partial<ActualAppointmentCollectionReq>) {
        this.newAppointments = value.newAppointments ?? []
        this.editAppointments = value.editAppointments ?? []
    }
}

export class ActualAppointmentUpdateReq extends ActualAppointmentReq {
    id!: number
}

export class ActualAppointmentRes {
    id!: number;
    startString!: string;
    endString!: string;
    description!: string;
    color: string = '#d2d2d2';
    _project: ProjectMinRes | undefined = undefined;
    task: BaseTaskRes | undefined = undefined;
    fromBackend: boolean = true

    set start(value: Date) {
        this.startString = value.toISOString()
    }

    get start(): Date {
        return new Date(this.startString);
    }

    set end(value: Date) {
        this.endString = value.toISOString()
    }

    get end(): Date {
        return new Date(this.endString)
    }

    get durationInMin(): number {
        let dur = this.end.getTime() - this.start.getTime();
        return dur / 60000
    }

    get height(): number {
        return this.decimalTimeToRelativeHeight(this.decimalEnd - this.decimalStart)
    }

    get transform(): number {
        return this.decimalTimeToRelativeHeight(this.decimalStart);
    }

    private get decimalStart(): number {
        return timeToDecimal(this.start)
    }

    private get decimalEnd(): number {
        return timeToDecimal(this.end)
    }

    private decimalTimeToRelativeHeight(decimalTime: number): number {
        return (decimalTime * 2880) / 2400
    }

    public blankAppointment(day: Date) {
        this.start = new Date(day.setHours(0, 0, 0, 0))
        this.end = new Date(day.setHours(0, 0, 0, 0))
        this.fromBackend = false;
        return this
    }

    public toRequest(): ActualAppointmentReq {
        return new ActualAppointmentReq(
            this.start,
            this.end,
            this.description,
            this.color,
            this.task!
        )
    }

    public toUpdate(): ActualAppointmentUpdateReq {
        let result = this.toRequest() as ActualAppointmentUpdateReq;
        result.id = this.id
        return result
    }

    public isValid(): boolean {
        return this.end.getTime() > this.start.getTime() && this.task != undefined;
    }

    get project(): ProjectMinRes | undefined {
        if (this._project !== undefined) {
            return this._project
        }
        if (this.task != undefined) {
            return this.task.project
        }
        return undefined;
    }

    set project(value: ProjectMinRes | undefined) {
        if (this._project !== undefined) {
            this._project = value
        }
    }
}


export class UsedTimePerYearRes {
    forYear!: number;
    @Type(() => UsedTimePerMonthRes)
    months: UsedTimePerMonthRes[] = []

    get actualHours() {
        return this.months.reduce((acc, cur) => acc + cur.actualHours, 0)
    }

    get targetHours() {
        return this.months.reduce((accumulator, current) => accumulator + current.targetHours, 0)
    }
}

export class UsedTimePerMonthRes {
    month: number = 0;
    @Type(() => UsedTimePerWeekRes)
    weeks: UsedTimePerWeekRes[] = []

    get actualHours() {
        return this.weeks.reduce((acc, cur) => acc + cur.actualHours, 0)
    }

    get targetHours() {
        return this.weeks.reduce((accumulator, current) => accumulator + current.targetHours, 0)
    }
}

export class UsedTimePerWeekRes {
    calendarWeek: number = 0;
    targetHours: number = 0;
    actualHours: number = 0;
}
